export const areaRoutes = {
	areas: (query?: string) => `/booths/${query ? `?${query}` : ''}`,
	area: (id: string) => `/booths/${id}/`,
	areaHistory: (id: string) => `/booths/${id}/history/`,
	areasDelete: '/booths/bulk_delete/',
	areasExport: '/booths/export/'
} as const
